export default __webpack_public_path__ + "static/media/Light.be36d7e9.png";